import { render, staticRenderFns } from "./ActivityResultForm.vue?vue&type=template&id=4c4df4a8&scoped=true&"
import script from "./ActivityResultForm.vue?vue&type=script&lang=js&"
export * from "./ActivityResultForm.vue?vue&type=script&lang=js&"
import style0 from "./ActivityResultForm.vue?vue&type=style&index=0&id=4c4df4a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4df4a8",
  null
  
)

export default component.exports